import { Component, OnInit, ViewChild } from '@angular/core';

import { MatDialog} from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';

import { EnvioCostoModel } from '../../models/envio/envio.model';
import { EnvioService } from '../../services/envio.service';
import { EnviocostoDialogComponent } from '../enviocosto-dialog/enviocosto-dialog.component';
import { EnviocostoImprimirDialogComponent } from '../enviocosto-imprimir-dialog/enviocosto-imprimir-dialog.component';


@Component({
  selector: 'app-enviocosto',
  templateUrl: './enviocosto.component.html',
  styleUrls: ['./enviocosto.component.css']
})
export class EnviocostoComponent implements OnInit {

  envioCostomodel: EnvioCostoModel;
  displayedColumns: string[] = [];
  datasource: any;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  dataSource: MatTableDataSource<any>;
  tabla: any[];


  constructor(private dialog: MatDialog,
              public paginatorInt: MatPaginatorIntl,
              private serviceEnvio: EnvioService) { }

  ngOnInit(): void {

            this.envioCostomodel = new EnvioCostoModel();
            this.envioCostomodel.idusuario = Number(sessionStorage.idu);
            this.envioCostomodel.idrol = Number(sessionStorage.idr);
            this.envioCostomodel.idsucursal = Number(sessionStorage.ids);
            this.envioCostomodel.idcosto_envio = 0;

            this.getGridEnvioCosto();

            this.paginatorInt.firstPageLabel = 'Primera página';
            this.paginatorInt.lastPageLabel = 'Última página';
            this.paginatorInt.itemsPerPageLabel = 'Registro por página';
            this.paginatorInt.nextPageLabel     = 'Siguiente página';
            this.paginatorInt.previousPageLabel = 'Anterior página';

  }

  reloadgrid() {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando registros ...'
    });
    Swal.showLoading();
    this.getGridEnvioCosto();
    Swal.close();
  }

  acceso(row) {
    this.openDialogEnvioCosto(row);
  }

  openDialogImprimir(rows): void {
    // if ( rows === undefined ) {
      const dialogRef = this.dialog.open( EnviocostoImprimirDialogComponent , {
        data: {titulo: 'Vista previa',
        row: rows
      },
      disableClose: true,
      height: String(screen.height * 0.90),
      width: String(screen.width * 0.90),
      });
      dialogRef.afterClosed().subscribe(result => {
       // this.getGridSucursal();
      });
    // }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.tablaFilter(filterValue.trim().toLowerCase());
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  tablaFilter(cadena: string) {

    // llenar la tabla para el reporte
    // const cadena = filterValue.trim().toLowerCase();
    const tablatemp = [];
    for (let i=0; i < this.tabla.length; i++) {
      if (this.tabla[i].rangoinicial.toString().trim().toLowerCase().indexOf(cadena) > -1 ||
          this.tabla[i].rangofinal.toString().trim().toLowerCase().indexOf(cadena) > -1 ||
          this.tabla[i].costo.toString().trim().toLowerCase().indexOf(cadena) > -1 ||
          this.tabla[i].tienda.trim().toLowerCase().indexOf(cadena) > -1
         ) {
        tablatemp.push(this.tabla[i]);
      }
    }
    this.tabla = [];
    this.tabla = tablatemp;
    console.log(tablatemp);
  }

  getGridEnvioCosto() {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando registros ...'
    });
    Swal.showLoading();
    this.displayedColumns = ['idcosto_envio', 'estaactivo', 'rangoinicial', 'rangofinal', 'costo', 'actions'];
    this.serviceEnvio.getGridCatEnvioCosto(this.envioCostomodel).subscribe( (resp: any[]) => {
          Swal.close();
          this.dataSource = new MatTableDataSource<any>(resp);
          this.tabla = resp;
          this.dataSource.paginator = this.paginator;
    }, (err) => {
      Swal.close();
      switch (err.status) {
      case 0:
          Swal.fire({
            icon: 'warning',
            text: 'No hay conexión con el servidor'
          });
          break;
       case 409:
         Swal.fire({
          icon: 'error',
          text: 'Error ' + err.status + ' para el grid de envios en el servidor'
         });
         break;
        case 500:
            Swal.fire({
              icon: 'error',
              text: 'Error ' + err.status + ' para el grid de envios en el servidor'
            });
            break;

      }
    });
  }

  openDialogEnvioCosto(rows: any) {
    if ( rows === undefined ) {
      const dialogRef = this.dialog.open( EnviocostoDialogComponent , {
        data: {titulo: 'Agregar el rango de envio',
          row: '',
        },
        disableClose: true,
        height: String(screen.height * 0.90),
        width: String(screen.width * 0.80),
        panelClass: 'full-screen-modal'
      });
      dialogRef.afterClosed().subscribe(result => {
       this.getGridEnvioCosto();
      });
    } else {
      const dialogRef = this.dialog.open( EnviocostoDialogComponent , {
        data: {titulo: 'Modificar el radio de entrega',
        row: rows
      },
      disableClose: true,
      height: String(screen.height * 0.90),
      width: String(screen.width * 0.80),
      });
      dialogRef.afterClosed().subscribe(result => {
        this.getGridEnvioCosto();
      });
    }

  }

  UpdBajaEnvio(UsuarioRow: any) {
    this.bajaEnvio(UsuarioRow);
  }

  bajaEnvio(row: any) {

    const username = row.rangoinicial + ' KM ' + '-' + row.rangofinal + ' KM ';

    // operacion
    // 1. insertar
    // 2. actualizar
    // 3. dar de baja
    // 4. restaurar usuario

    row.operacion = 2;
    row.estaactivo = false;
    row.idusuario = Number(sessionStorage.idu);
    // console.log(row);

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn ',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: true,
      confirmButtonColor: '#391410',
      cancelButtonColor: '#d01d17',
      confirmButtonText: 'Aceptar'
    } );

    swalWithBootstrapButtons.fire({
      title: '¿Dar de baja ' + username + '?',
      text: 'Confirme por favor',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {

          this.serviceEnvio.abcCatEnvioCosto(row).subscribe( (resp: any[]) => {
          Swal.close();

          // Swal.fire({
          //   icon: 'success',
          //   text: 'El extra ' + username + ' ha sido dado de baja.'
          // });

          // si regresa respuesta el servicio
          if (resp) {

            if (resp['idrespuesta'] > 0) {
              Swal.fire({
                icon: 'success',
                text: resp['respuesta']
              });
              this.getGridEnvioCosto();
              } else {
              Swal.fire({
                icon: 'error',
                text: resp['respuesta']
              });
              }
          }
          }, (err) => {
            Swal.close();
            switch (err.status) {
            case 0:
                Swal.fire({
                  icon: 'warning',
                  text: 'No hay conexión con el servidor'
                });
                break;
              case 409:
                Swal.fire({
                icon: 'error',
                text: 'Error ' + err.status + ' en el guardado del panel de envios'
                });
                break;
              case 500:
                  Swal.fire({
                    icon: 'error',
                    text: 'Error ' + err.status + ' en el guardado del panel de envios'
                  });
                  break;
            }
          });

          swalWithBootstrapButtons.fire(
            'Atencion!',
            'El envio ' + username + ' ha sido dado de baja.',
            'success'
          );

      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        swalWithBootstrapButtons.fire(
          'Cancelar',
          'La baja del envio no fue realizado!',
          'warning'
        );
      }
    });

  }

  updRestaurarEnvioCosto(row: any) {

    this.restaurarEnvioCosto(row);

  }

  restaurarEnvioCosto(row: any) {

    const username = row.rangoinicial + ' KM ' + '-' + row.rangofinal + ' KM ';

    // operacion
    // 1. insertar
    // 2. modificar
    // 3. dar de baja
    // 4. restaurar usuario

    row.operacion = 2;
    row.estaactivo = true;
    row.idusuario = Number(sessionStorage.idu);
    // console.log(row);

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn ',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: true,
      confirmButtonColor: '#391410',
      cancelButtonColor: '#d01d17',
      confirmButtonText: 'Aceptar'
    } );

    swalWithBootstrapButtons.fire({
      title: '¿Restaurar ' + username + '?',
      text: 'Confirme por favor',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {

          this.serviceEnvio.abcCatEnvioCosto(row).subscribe( (resp: any[]) => {
          Swal.close();

          Swal.fire({
            icon: 'success',
            text: 'EL envio ' + username + ' ha sido restaurado.'
          });

          // si regresa respuesta el servicio
          if (resp) {

            if (resp['idrespuesta'] > 0) {
              Swal.fire({
                icon: 'success',
                text: resp['respuesta']
              });
              this.getGridEnvioCosto();
              } else {
              Swal.fire({
                icon: 'error',
                text: resp['respuesta']
              });
              }
          }
          }, (err) => {
            Swal.close();
            switch (err.status) {
            case 0:
                Swal.fire({
                  icon: 'warning',
                  text: 'No hay conexión con el servidor'
                });
                break;
              case 409:
                Swal.fire({
                icon: 'error',
                text: 'Error ' + err.status + ' en el guardado del panel de envios'
                });
                break;
              case 500:
                  Swal.fire({
                    icon: 'error',
                    text: 'Error ' + err.status + ' en el guardado del panel de envios'
                  });
                  break;
            }
          });

          swalWithBootstrapButtons.fire(
            'Atencion!',
            'El envio ' + username + ' ha sido restaurado.',
            'success'
          );

      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        swalWithBootstrapButtons.fire(
          'Cancelar',
          'La restauración del envio no fue realizado.',
          'warning'
        );
      }
    });

  }

}
